export default {
  computed: {
    $typeAheadRolesData() {
      return [
        {
          uid: "a",
          text: "Journey Engineer"
        },
        {
          uid: "b",
          text: "Journey Guide"
        },
        {
          uid: "c",
          text: "Coach"
        },
        {
          uid: "d",
          text: "Product Manager"
        },
        {
          uid: "e",
          text: "Trainer"
        },
        {
          uid: "f",
          text: "Artist"
        },
        {
          uid: "g",
          text: "Employer"
        },
        {
          uid: "h",
          text: "Employee"
        },
        {
          uid: "i",
          text: "Financier"
        },
        {
          uid: "j",
          text: "Transportation"
        },
        {
          uid: "k",
          text: "Nutritionist"
        },
        ...this.$store.getters["user/listRoles"]
      ];
    }
  }
};
